var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var BezierEasing = require('bezier-easing');

var BellChart = createReactClass({
    mixins: [PureRenderMixin],

    easing: BezierEasing(0.93, 0.27, 0.8, 1),

    render: function(){
        return (
            <div className="bell-chart-wrap">
                <div className="bell-chart">
                    <div className="bell-chart-bar" style={{left: this.props.percentile + '%', height: this.easing((50 - Math.abs(this.props.percentile - 50))/50)*100 + 10 + '%'}}>
                        <div className="bell-chart-text">{this.props.percentile}</div>
                    </div>
                </div>
            </div>
        )
    }
});

module.exports = BellChart;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/bellChart.jsx